import Css from "./style.module.scss";

import { Select } from "nlib/ui";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import React, { useMemo } from "react";
import TaskStatuses from "const/TaskStatuses";
import classNames from "classnames";

const SelectTaskStatus = ({ className, disabled, value, onChange }) => {
  const { uiTexts } = useSelector(getTextsData);

  const options = useMemo(() => {
    return [
      { value: TaskStatuses.TO_DO, label: uiTexts[TaskStatuses.TO_DO] },
      { value: TaskStatuses.IN_PROGRESS, label: uiTexts[TaskStatuses.IN_PROGRESS] },
      { value: TaskStatuses.ON_HOLD, label: uiTexts[TaskStatuses.ON_HOLD] },
      { value: TaskStatuses.COMPLETED, label: uiTexts[TaskStatuses.COMPLETED] }
    ];
  }, [uiTexts]);

  return (
    <Select
      className={classNames(Css.selectTaskStatus, className)}
      dropDownClassName={Css.dropDownClassName}
      disabled={disabled}
      value={value}
      options={options}
      onChange={onChange} />
  );
};

export default React.memo(SelectTaskStatus);
